import qs from 'qs';
import { fetchGET } from 'api/fetchHelper';

const PATH = '/_api/v1/versions';

const Versions = {
  getAll: ({ page, filter, fields, include }) => (
    fetchGET(`${PATH}?${qs.stringify({ page, filter, fields, include }, { encodeValuesOnly: true })}`)
  ),
};

export default Versions;
